import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** shadcn's class combiner: clsx for conditionals, tailwind-merge so a
 *  caller's `className` overrides a component's defaults instead of
 *  fighting them. */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
